import { Input, InputProps } from "antd-mobile"

export const InputNumber = (props: InputProps) => {
  return <Input {...props} />
}
